import React, { useState } from 'react';
import { fetchUserApi } from '../../services/Api';
import { apiURLs } from '../../constants/ApiURLs';
import { COOKIE, createCookie, getCookie } from '../../services/Cookie';
import { message } from 'antd';
import constants from '../../constants/Constants';
const UserContext = React.createContext();

function ContextProvider(props) {
	const [cartCount, setCartCount] = useState(getCookie(COOKIE.CartCount)||0);
	const getCartCount = (userID)=>{
		fetchUserApi(`${apiURLs.CartCount}/${userID}`, 'GET',null,true).then((res) => {
			if (res?.code === 200) {
				if(res?.data?.cart_count){
					setCartCount(res?.data?.cart_count);
					createCookie(COOKIE.CartCount,res?.data?.cart_count, null, "/");
				}else{
					setCartCount(0);
					createCookie(COOKIE.CartCount,0, null, "/");
				}
			} else {
				setCartCount(0);
				createCookie(COOKIE.CartCount,0, null, "/");
			}
		}).catch(() => {
			setCartCount(0);
			createCookie(COOKIE.CartCount,0, null, "/");
			message.error(constants.ErrorMessage);
		});
	}
	let contextProps = {
		cartCount,
		setCartCount,
		getCartCount,
	}
	return (
		<UserContext.Provider value={{ ...contextProps }}>
			{props.children}
		</UserContext.Provider>
		)
}
export {ContextProvider,UserContext}
